import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';
const orderBy = require('lodash/orderBy');

import AccessButton from '../common/AccessButton';
import DateString from '../common/DateString';
import ActivityIcon from '../activity/ActivityIcon';
const SortUtil = require('../../util/SortUtil');

const propTypes = {
    className: PropTypes.string,
    activities: PropTypes.array.isRequired,
    filterActive: PropTypes.bool.isRequired,
    activityMatchesFilter: PropTypes.func.isRequired,
    sortObj: SortUtil.SortObjPropType.isRequired,
    depth: PropTypes.number,
};

const defaultProps = {
    className: '',
    depth: 0,
};

function ProjectActivityList(props) {
    if (!props.activities) {
        return null;
    }

    // this sortObj is set up to work using keys of project object.
    // modified & created_at are keys which also belong to the activity object
    // and should be sorting using these keys if present.
    // if neither, sort by activity name
    let sortedActivities;
    if (props.sortObj.key === 'modified' || props.sortObj.key === 'created_at') {
        sortedActivities = SortUtil.sortObjectArray(props.activities, props.sortObj);
    }
    else {
        sortedActivities = orderBy(props.activities, (act) => act.meta_data.title.toLowerCase());
    }

    return (
        <ul>
            {sortedActivities.map((activity) => {
                const actViewHref = `/project/${activity.owner_id}/${activity.project_id}/activity/${activity.id}`;

                return (
                    <li className={`activityListItem ${props.filterActive && props.activityMatchesFilter(activity) ? 'highlight' : ''} ${props.className}`} key={activity.id}>
                        <Row className="activityListItem__wrapper">
                            <Link to={actViewHref} className={`col-3 col-sm-2 col-md-1 activityListItem__col--control activityListItem__col--depth-${props.depth} nowrap`}>
                                <div className="listDepthWrapper">
                                    <ActivityIcon className="nav-menu-act-image" activity={activity} />
                                </div>
                            </Link>
                            <Link to={actViewHref} className="activityListItem__col--clipText col-7 col-sm-7 col-md-5 col-lg-3 link-plain link-body-color">
                                <div title={activity.meta_data.title}>{activity.meta_data.title}</div>
                            </Link>
                            <Link to={actViewHref} className="activityListItem__col d-none d-md-flex col-md-2 col-lg-2 link-plain link-body-color nowrap text-md">
                                <DateString shortMonth date={activity.created_at} />
                            </Link>
                            <Link to={actViewHref} className="activityListItem__col d-none d-md-flex col-md-2 col-lg-2 link-plain link-body-color nowrap text-md">
                                { activity.modified ?
                                    <DateString shortMonth date={activity.modified} />
                                    :
                                    'Never'
                                }
                            </Link>
                            <div className="activityListItem__col d-none d-lg-flex col-lg-4">
                                {/*TODO: check canPreview permission*/}
                                <AccessButton
                                className="margin-left-xl"
                                iconPath={`${GlobalConfig.StaticUrl}/img/Play.svg`}
                                iconStyle={{width:'24px'}}
                                text="preview"
                                href={`/project/${activity.owner_id}/${activity.project_id}/activity/${activity.id}/preview`}
                                />
                            </div>
                        </Row>
                    </li>
                );
            })}
        </ul>
    );
}

ProjectActivityList.propTypes = propTypes;
ProjectActivityList.defaultProps = defaultProps;

export default ProjectActivityList;
